import clsx from 'clsx'

// Style
import './style.scss'

import { useAppSelector } from 'shared/hooks'
import { typo } from 'shared/styles'

import { appSelectors } from '../../../redux/reducers/app'
import { DropDownMenu } from './dropDownMenu'
import css from './UserHeaderWidget.module.scss'

export function UserProfilePersona() {
	const email = useAppSelector(
		state => appSelectors.persona(state)?.email ?? ''
	)
	const fullName = useAppSelector(appSelectors.fullName)

	if (!email) {
		return null
	}

	return (
		<>
			<button
				className={clsx(css.trigger, typo.buttonSm)}
				// @ts-ignore
				popovertarget={'header-user-menu'}
				popovertargetaction='toggle'
				type='button'
			>
				<span className={css.name}>{fullName}</span>
				<span>{email}</span>
			</button>

			<DropDownMenu />
		</>
	)
}
